import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./FilterComponentStyles";
import {ObjectionStatusFilterPropTypes} from "./FilterComponentPropTypes";
import {useObserver} from "mobx-react-lite";
import {arrayAlphabeticalSort} from "../../../utils/helpers";
import {dayOffStatuses} from "../../../constants/constants";
const DayOffStatusFilter = ({
    allKey = "all",
    showAll = true,
    hideTitle = false,
    ...props
}: ObjectionStatusFilterPropTypes) => {
    const {t} = useTranslation(["dayOffStatuses"]);

    return useObserver(() => (
        <React.Fragment>
            {!hideTitle && <h5>{t("fields.status", {ns: "common"})}</h5>}
            <SelectField
                allowClear
                showSearch
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                data-testid="dayOffStatusSelect"
                {...props}
            >
                {showAll && (
                    <SelectField.Option value={allKey} data-testid="dayOffStatusSelect_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}

                {arrayAlphabeticalSort([...dayOffStatuses], "value").map(dayOffStatus => (
                    <SelectField.Option
                        key={dayOffStatus.value}
                        value={dayOffStatus.value}
                        data-testid="dayOffStatusSelect_option"
                    >
                        {t(dayOffStatus.translation_key, {ns: "dayOffStatuses"})}
                    </SelectField.Option>
                ))}
            </SelectField>
        </React.Fragment>
    ));
};

export default DayOffStatusFilter;
